// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"40792b7d","692":"77703263","895":"8ce274f6"}[chunkId] + ".chunk.js";
};